import { ColorItem, Maybe } from "@/types/graphql.prod"
import { Dispatch, SetStateAction } from "react"
import classes from "./customizeOptions.module.css"
import { useIsMobile } from "@/hooks/use-is-mobile"

export const CustomizeOptions = ({
  colorOptions,
  allColorCount,
  selectedColor,
  setSelectedColor,
  outOfStock,
  url_key,
}: {
  colorOptions: Maybe<ColorItem>[]
  allColorCount: number
  selectedColor: Maybe<ColorItem> | undefined
  setSelectedColor: Dispatch<SetStateAction<Maybe<ColorItem> | undefined>>
  outOfStock: boolean | undefined
  url_key: string
}) => {
  const handleClick = (value: ColorItem) => {
    setSelectedColor(value)
  }

  const { isMobile } = useIsMobile()

  return (
    <div
      className="mb-[10px] flex items-center"
      style={{
        opacity: outOfStock ? 0.5 : 1,
      }}
    >
      <ul className={classes.items}>
        {colorOptions.map((value, index) => {
          const image = value?.image
          const hover_image = value?.hover_image

          let blockStyle

          if (image) {
            blockStyle = {
              backgroundImage: `url(${hover_image})`,
            }
          } else {
          }

          const itemClass =
            selectedColor?.image === image ? classes.activeItem : classes.item

          return (
            <div
              aria-hidden="true"
              className={itemClass}
              key={index}
              onClick={(e) => {
                e.preventDefault()

                if (value) {
                  handleClick(value)
                }
              }}
              style={blockStyle}
            />
          )
        })}
      </ul>
      {allColorCount && allColorCount > 3 && isMobile && (
        <span className="ml-[8px] font-sans text-sm leading-[1.4] text-[#666]">
          {`+${allColorCount - 3}`}
        </span>
      )}
      {allColorCount && !isMobile && (
        <span className="ml-[10px] font-sans text-sm leading-[1.4] text-[#666]">
          {`${allColorCount} Color${allColorCount > 1 ? "s" : ""}`}
        </span>
      )}
    </div>
  )
}
